module.exports = __webpack_public_path__ + "assets/img/vue_template_style_computed.9627febb.jpg";